<template>
  <div>
    <div class="container-fluid my-2">
      <div class="card-body">
        <div class="panel-body">
          <multi-selection-picker
            v-if="!readOnly"
            :all-items="availables"
            :allow-item-list-editing="!readOnly"
            :column-count="1"
            item-type-name="Fortaleza"
            maxlength="1500"
            :modify-removes-item="true"
            :selected-items="selectedStrengths"
            @add-item="addStrength"
            @delete-item="deleteStrength"
            @edit-item="editStrength"
          />
          <div v-if="!readOnly" class="row mt-3">
            <div class="col-12">
              <error
                is-alert-mode
                message="Puede seleccionar una(1) o más fortalezas. Selección múltiple."
              />
            </div>
          </div>
          <custom-chips-group
            :disabled="readOnly"
            no-background
            no-wrap
            object-text="name"
            :on-item-deleted="removeSelection"
            :selected-items="selectedStrengths"
            title="Fortalezas Seleccionadas"
          />
        </div>
      </div>
    </div>
    <div v-if="!readOnly" class="actions">
      <action-button i="fas fa-save" variant="success m-2" @click="save">
        Guardar
      </action-button>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomChipsGroup from 'CustomChipsGroup';
import Error from 'custom-error';
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

//services
import {
  getMeasureBankByUser as _getMeasureBankByUser,
  saveMeasureBankByUser as _saveMeasureBankByUser,
  deleteMeasureBankByUser as _deleteMeasureBankByUser,
} from '@/services/uspqrp/intervention-plan.api.js';

//utils
import measureBankTypes from '@/utils/constants/measureBankTypes.js';

export default {
  name: 'StrenghtsSection',
  components: {
    ActionButton,
    CustomChipsGroup,
    Error,
    MultiSelectionPicker,
  },
  mixins: [alertMixin],
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    disciplineTypeId: {
      type: Number,
      default: 0,
    },
    strengths: {
      type: Array,
      default: new Array(),
    },
  },
  data() {
    return {
      availableStrengths: [],
      deletedStrengths: [],
    };
  },
  computed: {
    availables() {
      return this.availableStrengths.filter(
        (x) => !this.selectedStrengths.some((s) => s.name === x.name)
      );
    },
    selectedStrengths: {
      get() {
        return this.strengths;
      },
      set(value) {
        this.$emit('update:strengths', value);
      },
    },
  },
  async mounted() {
    await this.getMeasureBankByUser();
  },
  methods: {
    removeSelection(item) {
      let editedItemIndex = this.selectedStrengths.findIndex(
        (e) => e.id === item.id
      );
      this.selectedStrengths.splice(editedItemIndex, 1);
    },
    async addStrength(description) {
      const { data: response } = await _saveMeasureBankByUser({
        id: null,
        measureTypeId: measureBankTypes.Strengths,
        disciplineTypeId: this.disciplineTypeId,
        description: description,
      });
      this.availableStrengths.push({
        id: response.id,
        name: response.name,
      });
    },
    async editStrength(item, index) {
      if (item.id > 0) {
        item.isDirty = true;
        const { data: response } = await _saveMeasureBankByUser({
          id: item.id,
          measureTypeId: measureBankTypes.Strengths,
          disciplineTypeId: this.disciplineTypeId,
          description: item.name,
        });
        this.availableStrengths.splice(index, 1, {
          ...this.availableStrengths[index],
          name: response.name,
        });
      }
    },
    async deleteStrength(item) {
      let response = await this.ShowCancelModal(
        'Atención',
        `¿Esta seguro que desea eliminar la fortaleza "${item.name}"?`,
        'Aceptar',
        'Cancelar'
      );

      if (response) {
        let itemIndex = this.availableStrengths.findIndex(
          (e) => e.id === item.id
        );
        this.availableStrengths.splice(itemIndex, 1);
        this.deletedStrengths.push(item);
        await _deleteMeasureBankByUser(item.id);
      }
    },
    async save() {
      this.$emit('save');
    },
    async getMeasureBankByUser() {
      const { data: response } = await _getMeasureBankByUser(
        this.disciplineTypeId
      );
      if (response && response.length > 0) {
        this.availableStrengths = response.filter(
          (x) => x.measureTypeId === measureBankTypes.Strengths
        );
      }
    },
  },
};
</script>
<style scoped>
.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
